module.exports = __webpack_public_path__ + "img/logo_bwgl.9dd779c1.gif";